import { ArticlePage } from '../../model/components/ArticlePage';
import {
    isStorefrontLinkPage,
    StorefrontLinkPostData,
} from '../../model/templates/StorefrontLinkTemplate';
import { PathContextProvider } from '../../PathContext';
import { ArticlePageInput } from './ArticlePageInput';

import { assert } from '../../../utils/assert';

export interface StorefrontLinkPostInputProps {
    value: StorefrontLinkPostData;
    onChange?: (value: StorefrontLinkPostData) => void;
}

export const StorefrontLinkPostInput = ({
    value,
    onChange,
}: StorefrontLinkPostInputProps) => {
    const [frontPage] = value.pages;
    const onFrontPageChange = (page: ArticlePage) => {
        assert(
            isStorefrontLinkPage(page),
            'Button is not allowed to be undefined',
        );

        onChange?.({
            ...value,
            pages: [page],
        });
    };

    return (
        <PathContextProvider segment="pages">
            <PathContextProvider segment={0}>
                <ArticlePageInput
                    value={frontPage}
                    onChange={onFrontPageChange}
                    pageIndex={0}
                    button={{
                        enabled: true,
                        allowedActions: ['OpenInStore'],
                    }}
                />
            </PathContextProvider>
        </PathContextProvider>
    );
};
